import React, { useState } from 'react';

function Line({ startX, startY, angle, distance }) {

    return (
      <>
        {/* Linia strzałki */}
        <div
          style={{
            position: 'absolute',
            top: `${startY}px`,
            left: `${startX}px`,
            width: `${distance}px`,
            height: '2px',
            backgroundColor: 'red',
            transform: `rotate(${angle}deg)` ,
            transformOrigin: '0 0',
            zIndex: 1000,
          }}
        />

      </>
    );
}

export default Line;